export const environment = {
  production: false,
  environment: 'local',
  apiBaseURL: 'https://api-test.edusupportcenter.com/api',
  api_vi: 'api/v1/',
  default_dept_id:"1",
  shplogin: "/smartview/chat/config",
  shp_active_check: 'api/v1/shp/config/',
  headerConfig: 'api/v1/shp/headerconfig/',
  loginConfig: 'api/v1/shp/loginConfig/',
  login: 'api/v1/shp/login/',
  dbForogtPwdReset: 'api/v1/shp/dbAuthPwdReset/',
  refreshToken: '/api/v1/secureshp/refreshToken',
  reset: '/api/v1/shp/pwdreset/reset/',
  footerConfig: 'api/v1/shp/footerconfig/',
  i18n: 'api/v1/i18n?channel=shp&component=common&local=',
  topArticles: '/internal/topArticles',
  quickLinks: 'api/v1/shp/quicklinks/',
  guidedHelp: '/shp/rootTopics',
  getChildrenTopics: '/shp/getChildren/',
  autocomplete: 'shp/autocomplete/',
  searchresults: '/shp/kb/searchKbArticle',
  viewArticles: '/shp/kb/view/',
  feedback: '/internal/article/feedback',
  pwdResetConfig: '/shp/pwdResetConfig',
  chat: '/chatInvitation',
  pwdRestEmail: '/pwdreset/reset',
  valitateToken: 'api/v1/shp/pwdreset/validate_token',
  modifyPassword: '/modifyPwdConfig',
  ldapPwdResetConfig: '/ldapAuthPwdReset',
  inactiveTimeOutMinutes: 30,
  fakeBackendPwr : 'test',
  localhost: false,
  createCase: '/shplite/case/field',
  submitCase: '/case',
  customerConfig: '/shplite/contact/customization',
  dependencyConfiguration: '/shplite/case/option/',
  dependencyTemplate: '/dependency?template_type=HELP_CENTER',
  fileUpload: "/internal/file/upload",
  ticketFields: "/shp/ticketConfig",
  helpCenterFields: "/shp/myHelpCenter",
  CaseFields: "/shp/helpCenter/case",
  topTenArticle: "/shp/getTopTenConfig",
  kbSearchConfig: "/shp/kbSearchConfig",
  viewCase: "/shp/case/",
  gdHelp: "/shp/gdHelp",
  priavacyStatement: "/internal/privacystatement",
  isOfficeTime: "/isOfficeTime",
  contact: "/prechat/contact/",
  chatServerUrl: "https://chat-test.edusupportcenter.com",
  chatPopUp: "/internal/advisor/chatQueue",
  officeTime: "/case/officeTime",
  message: "/hourMessageInfo",
  default: "/internal/default",
  captcha: {
    siteKey: "c5950155-1263-4c16-88ef-3b498f082911",
    languageCode: "en"
  },
  saml_auth: "api/v1/secureshp/samlAuthenticatedUser/",
  cas_auth: "api/v1/secureshp/casAuthenticatedUser/",
  samlUserName: "samluser",
  casUserName: "casuser",
  headerTitle:"headertitle/",
  deleteToken: "/api/v1/secureshp/deleteToken",
  logonWarning : "/pwd/configuration"
};



